import {Component, OnInit} from '@angular/core';
import {NavigationTriggerService} from '@app/services/admin/navigation-trigger.service';

@Component({
    selector: 'app-resolution-classification-landing',
    templateUrl: './resolution-classification-landing.component.html'
})

export class ResolutionClassificationLandingComponent implements OnInit {
    constructor(private navigationTriggerService: NavigationTriggerService) {
    }

    ngOnInit() {
        this.navigationTriggerService.setSubMenu(false);
      }
}
